import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import {
  FaRegUser,
  FaCheck,
  FaTimes,
  FaInstagram,
  FaWhatsapp,
  FaArrowRight,
  FaUsers,
  FaPaperPlane,
} from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { MdSubject } from "react-icons/md";

const ContactDetails = () => {
  const form = useRef();

  const [showSuccess, setShowSuccess] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();

    if (isSending) return;

    setIsSending(true);

    try {
      const result = await emailjs.sendForm(
        "service_6v7b66h",
        "template_asaqh0n",
        form.current,
        "j0SWpbqzRIFPLeqlq"
      );

      console.log("Email uğurla göndərildi:", result.text);

      if (result.status === 200) {
        setShowSuccess(true);
        form.current.reset();
      }
    } catch (error) {
      console.error("Email göndərilmədi:", error);

      alert(
        "Mesaj göndərilərkən xəta baş verdi. Zəhmət olmasa yenidən cəhd edin."
      );
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section className="relative min-h-screen overflow-hidden bg-gray-50 py-16 transition-colors duration-500 dark:bg-[#070b0f] sm:py-20 lg:py-24">

      {/* BACKGROUND DECORATION */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-32 -top-32 h-72 w-72 rounded-full bg-green-400/10 blur-3xl dark:bg-green-500/10" />
        <div className="absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-emerald-400/10 blur-3xl dark:bg-emerald-500/10" />

        <div className="absolute left-1/2 top-0 h-px w-[70%] -translate-x-1/2 bg-gradient-to-r from-transparent via-green-500/20 to-transparent" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

        {/* ================= HEADER ================= */}
        <div className="mx-auto mb-14 max-w-3xl text-center">

          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-green-200 bg-green-50 px-4 py-2 text-sm font-semibold text-green-600 dark:border-green-500/20 dark:bg-green-500/10 dark:text-green-400">
            <span className="h-2 w-2 animate-pulse rounded-full bg-green-500" />
            Bizimlə əlaqə saxlayın
          </div>

          <h2 className="text-4xl font-black tracking-tight text-gray-900 dark:text-white sm:text-5xl lg:text-6xl">
            Sizinlə{" "}
            <span className="bg-gradient-to-r from-green-500 to-emerald-400 bg-clip-text text-transparent">
              əlaqə
            </span>{" "}
            saxlayaq
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-gray-500 dark:text-gray-400 sm:text-lg">
            Sualınız, təklifiniz və ya əməkdaşlıq fikriniz varsa,
            bizə yazın. Sizə ən qısa zamanda cavab verməyə çalışacağıq.
          </p>
        </div>

        {/* ================= MAIN GRID ================= */}
        <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr]">

          {/* ================= LEFT SIDE ================= */}
          <div className="flex flex-col gap-5">

            {/* INSTAGRAM */}
            <a
              href="https://instagram.com/akberofh"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden rounded-3xl border border-gray-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-pink-300 hover:shadow-xl dark:border-gray-800 dark:bg-[#0d1318] dark:hover:border-pink-500/30"
            >
              <div className="absolute -right-10 -top-10 h-28 w-28 rounded-full bg-pink-500/10 blur-2xl transition-all duration-500 group-hover:scale-150" />

              <div className="relative flex items-center gap-5">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 text-2xl text-white shadow-lg shadow-pink-500/20">
                  <FaInstagram />
                </div>

                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Instagram
                  </p>

                  <h3 className="mt-1 truncate text-lg font-bold text-gray-900 dark:text-white">
                    @akberofh
                  </h3>
                </div>

                <FaArrowRight className="text-gray-300 transition-all duration-300 group-hover:translate-x-1 group-hover:text-pink-500 dark:text-gray-600" />
              </div>
            </a>

            {/* WHATSAPP */}
            <a
              href="https://wa.me/994515983550"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden rounded-3xl border border-gray-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-green-300 hover:shadow-xl dark:border-gray-800 dark:bg-[#0d1318] dark:hover:border-green-500/30"
            >
              <div className="absolute -right-10 -top-10 h-28 w-28 rounded-full bg-green-500/10 blur-2xl transition-all duration-500 group-hover:scale-150" />

              <div className="relative flex items-center gap-5">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-green-500 text-2xl text-white shadow-lg shadow-green-500/20">
                  <FaWhatsapp />
                </div>

                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                    WhatsApp
                  </p>

                  <h3 className="mt-1 text-lg font-bold text-gray-900 dark:text-white">
                    +994 51 598 35 50
                  </h3>
                </div>

                <FaArrowRight className="text-gray-300 transition-all duration-300 group-hover:translate-x-1 group-hover:text-green-500 dark:text-gray-600" />
              </div>
            </a>

            {/* TEAM CARD */}
            <a
              href="https://chat.whatsapp.com/GpXwAPiRHLHFIMz4BE7s5e?s=cl&p=a&mlu=4&ilr=4"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-green-500 via-emerald-500 to-teal-600 p-[1px] shadow-xl shadow-green-500/10 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-green-500/20"
            >
              <div className="relative overflow-hidden rounded-[23px] bg-white p-6 dark:bg-[#0b1115]">

                <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-green-500/10 blur-3xl transition-transform duration-700 group-hover:scale-150" />

                <div className="relative flex items-start gap-5">

                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-green-500 text-xl text-white shadow-lg shadow-green-500/20">
                    <FaUsers />
                  </div>

                  <div className="flex-1">
                    <div className="flex items-center justify-between gap-3">
                      <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-bold text-green-600 dark:bg-green-500/10 dark:text-green-400">
                        KOMANDA
                      </span>

                      <FaArrowRight className="text-green-500 transition-transform duration-300 group-hover:translate-x-1" />
                    </div>

                    <h3 className="mt-3 text-xl font-black text-gray-900 dark:text-white">
                      Komandamıza qoşulun
                    </h3>

                    <p className="mt-2 text-sm leading-6 text-gray-500 dark:text-gray-400">
                      Bizimlə birlikdə inkişaf etmək və yeni imkanlardan
                      yararlanmaq istəyirsinizsə, WhatsApp qrupumuza qoşulun.
                    </p>

                    <div className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-green-600 dark:text-green-400">
                      WhatsApp qrupuna keç
                      <FaArrowRight className="text-xs transition-transform duration-300 group-hover:translate-x-1" />
                    </div>
                  </div>
                </div>
              </div>
            </a>

            {/* SMALL INFO */}
            <div className="rounded-3xl border border-gray-200 bg-gray-100/70 p-6 dark:border-gray-800 dark:bg-[#0b1014]">
              <div className="flex gap-4">
                <div className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full bg-green-500 shadow-lg shadow-green-500/50" />

                <div>
                  <h4 className="font-bold text-gray-900 dark:text-white">
                    Sürətli cavab
                  </h4>

                  <p className="mt-1 text-sm leading-6 text-gray-500 dark:text-gray-400">
                    Mesajınızı göndərin, imkan daxilində ən qısa zamanda
                    sizinlə əlaqə saxlayacağıq.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ================= CONTACT FORM ================= */}
          <div className="relative overflow-hidden rounded-[2rem] border border-gray-200 bg-white p-6 shadow-xl shadow-gray-200/50 dark:border-gray-800 dark:bg-[#0d1318] dark:shadow-black/30 sm:p-8 lg:p-10">

            {/* FORM GLOW */}
            <div className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full bg-green-500/5 blur-3xl" />

            <div className="relative">

              <div className="mb-8">
                <div className="mb-3 flex items-center gap-3">
                  <div className="h-10 w-10 rounded-xl bg-green-100 p-2.5 text-green-600 dark:bg-green-500/10 dark:text-green-400">
                    <FaPaperPlane className="h-full w-full" />
                  </div>

                  <div>
                    <h3 className="text-2xl font-black text-gray-900 dark:text-white">
                      Bizə mesaj yazın
                    </h3>

                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                      Formu doldurun və mesajınızı bizə göndərin.
                    </p>
                  </div>
                </div>
              </div>

              <form
                ref={form}
                onSubmit={sendEmail}
                className="space-y-5"
              >

                {/* NAME */}
                <div>
                  <label className="mb-2 block text-sm font-semibold text-gray-700 dark:text-gray-200">
                    Adınız
                  </label>

                  <div className="group relative">
                    <FaRegUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 transition-colors group-focus-within:text-green-500 dark:text-gray-500" />

                    <input
                      type="text"
                      name="user_name"
                      required
                      placeholder="Adınızı daxil edin"
                      className="w-full rounded-2xl border border-gray-200 bg-gray-50 py-3.5 pl-11 pr-4 text-sm text-gray-900 outline-none transition-all placeholder:text-gray-400 focus:border-green-500 focus:bg-white focus:ring-4 focus:ring-green-500/10 dark:border-gray-700 dark:bg-gray-800/60 dark:text-white dark:placeholder:text-gray-500 dark:focus:border-green-500 dark:focus:bg-gray-800"
                    />
                  </div>
                </div>

                {/* EMAIL */}
                <div>
                  <label className="mb-2 block text-sm font-semibold text-gray-700 dark:text-gray-200">
                    E-poçt
                  </label>

                  <div className="group relative">
                    <HiOutlineMail className="absolute left-4 top-1/2 -translate-y-1/2 text-xl text-gray-400 transition-colors group-focus-within:text-green-500 dark:text-gray-500" />

                    <input
                      type="email"
                      name="user_email"
                      required
                      placeholder="example@email.com"
                      className="w-full rounded-2xl border border-gray-200 bg-gray-50 py-3.5 pl-11 pr-4 text-sm text-gray-900 outline-none transition-all placeholder:text-gray-400 focus:border-green-500 focus:bg-white focus:ring-4 focus:ring-green-500/10 dark:border-gray-700 dark:bg-gray-800/60 dark:text-white dark:placeholder:text-gray-500 dark:focus:border-green-500 dark:focus:bg-gray-800"
                    />
                  </div>
                </div>

                {/* SUBJECT */}
                <div>
                  <label className="mb-2 block text-sm font-semibold text-gray-700 dark:text-gray-200">
                    Mövzu
                  </label>

                  <div className="group relative">
                    <MdSubject className="absolute left-4 top-1/2 -translate-y-1/2 text-xl text-gray-400 transition-colors group-focus-within:text-green-500 dark:text-gray-500" />

                    <input
                      type="text"
                      name="subject"
                      required
                      placeholder="Mesajınızın mövzusu"
                      className="w-full rounded-2xl border border-gray-200 bg-gray-50 py-3.5 pl-11 pr-4 text-sm text-gray-900 outline-none transition-all placeholder:text-gray-400 focus:border-green-500 focus:bg-white focus:ring-4 focus:ring-green-500/10 dark:border-gray-700 dark:bg-gray-800/60 dark:text-white dark:placeholder:text-gray-500 dark:focus:border-green-500 dark:focus:bg-gray-800"
                    />
                  </div>
                </div>

                {/* MESSAGE */}
                <div>
                  <label className="mb-2 block text-sm font-semibold text-gray-700 dark:text-gray-200">
                    Mesajınız
                  </label>

                  <textarea
                    name="message"
                    required
                    rows="6"
                    placeholder="Buraya mesajınızı yazın..."
                    className="w-full resize-none rounded-2xl border border-gray-200 bg-gray-50 px-4 py-3.5 text-sm leading-6 text-gray-900 outline-none transition-all placeholder:text-gray-400 focus:border-green-500 focus:bg-white focus:ring-4 focus:ring-green-500/10 dark:border-gray-700 dark:bg-gray-800/60 dark:text-white dark:placeholder:text-gray-500 dark:focus:border-green-500 dark:focus:bg-gray-800"
                  />
                </div>

                {/* SEND BUTTON */}
                <button
                  type="submit"
                  disabled={isSending}
                  className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-gradient-to-r from-green-500 to-emerald-500 px-6 py-4 text-sm font-bold text-white shadow-lg shadow-green-500/20 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-green-500/30 disabled:cursor-not-allowed disabled:opacity-70"
                >
                  {isSending ? (
                    <>
                      <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/30 border-t-white" />
                      Göndərilir...
                    </>
                  ) : (
                    <>
                      <FaPaperPlane className="transition-transform duration-300 group-hover:translate-x-1" />
                      Mesajı göndər
                    </>
                  )}
                </button>

                <p className="text-center text-xs text-gray-400 dark:text-gray-500">
                  Göndərdiyiniz məlumatlar yalnız sizinlə əlaqə saxlamaq üçün
                  istifadə olunur.
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* ================= SUCCESS MODAL ================= */}
      {showSuccess && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4 backdrop-blur-md dark:bg-black/70">

          <div className="relative w-full max-w-md animate-[popupIn_.35s_ease-out] rounded-[2rem] border border-gray-100 bg-white p-8 text-center shadow-2xl dark:border-gray-800 dark:bg-[#10171c] sm:p-10">

            {/* CLOSE */}
            <button
              type="button"
              onClick={() => setShowSuccess(false)}
              className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full text-gray-400 transition-all hover:bg-gray-100 hover:text-gray-700 dark:text-gray-500 dark:hover:bg-gray-800 dark:hover:text-white"
            >
              <FaTimes />
            </button>

            {/* SUCCESS ICON */}
            <div className="relative mx-auto mb-6 flex h-24 w-24 items-center justify-center">

              <div className="absolute inset-0 animate-ping rounded-full bg-green-500/10" />

              <div className="relative flex h-20 w-20 animate-[checkScale_.5s_ease-out] items-center justify-center rounded-full bg-green-100 dark:bg-green-500/10">
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-green-500 text-2xl text-white shadow-lg shadow-green-500/30">
                  <FaCheck />
                </div>
              </div>
            </div>

            <h3 className="text-2xl font-black text-gray-900 dark:text-white">
              Mesaj uğurla göndərildi! 🎉
            </h3>

            <p className="mx-auto mt-3 max-w-sm text-sm leading-6 text-gray-500 dark:text-gray-400">
              Mesajınız uğurla qəbul edildi. Ən qısa zamanda sizinlə
              əlaqə saxlayacağıq.
            </p>

            <button
              type="button"
              onClick={() => setShowSuccess(false)}
              className="mt-7 w-full rounded-2xl bg-green-500 px-6 py-3.5 text-sm font-bold text-white shadow-lg shadow-green-500/20 transition-all hover:-translate-y-0.5 hover:bg-green-600 hover:shadow-xl"
            >
              Bağla
            </button>
          </div>
        </div>
      )}

      {/* ================= ANIMATIONS ================= */}
      <style>{`
        @keyframes popupIn {
          from {
            opacity: 0;
            transform: translateY(20px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        @keyframes checkScale {
          0% {
            transform: scale(0);
            opacity: 0;
          }
          70% {
            transform: scale(1.08);
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </section>
  );
};

export default ContactDetails;
